module.exports = __webpack_public_path__ + "1f25e2689b024152e43ebf126f2ee3ff.svg";